var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 64C110 64 0 125.875 0 208V306.125C0 384.5 114.625 448 256 448S512 384.5 512 306.125V208C512 125.875 402 64 256 64ZM256 112C366.5 112 456 147.875 456 192C456 201.125 452 209.75 445 217.875C398.25 192.25 331 176 256 176S113.75 192.25 67 217.875C60 209.75 56 201.125 56 192C56 147.875 145.5 112 256 112ZM397.75 248.5C361.5 263 311.375 272 256 272S150.5 263 114.25 248.5C150 234.25 198.375 224 256 224S362 234.25 397.75 248.5ZM464 306.125C464 344.375 383 400 256 400S48 344.375 48 306.125V266.375C94.375 298.75 170.125 320 256 320S417.625 298.75 464 266.375V306.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.49be1be6265346cd126ba19fe3fb9716.svg";
export { ForwardRef as ReactComponent };